<template>
  <!--
      作者：wangxw
      时间：2020-06-10
      描述：页面-页面列表
  -->
  <div class="user">
    <!--添加页面-->
    <div class="common-level-rail">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick()" v-auth="'/page/page/add'">
        添加模版
      </el-button>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="pageId" label="页面ID" width="80"></el-table-column>
          <el-table-column prop="pageName" label="页面名称"></el-table-column>
          <!--          <el-table-column align="center" prop="pageStatus" label="页面状态" width="80">-->
          <!--            <template slot-scope="scope">-->
          <!--              <span :style="{color:scope.row.pageStatus === 0 ? 'green' : 'red'}">{{-->
          <!--                  scope.row.pageStatus === 0 ? '启用' : '禁用'-->
          <!--                }}</span>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <!--          <el-table-column prop="templateCover" label="模版封面" width="80">-->
          <!--            <template slot-scope="scope">-->
          <!--              <div style="position: relative;width: 60px;height: 60px;background: #F0F0EE;">-->
          <!--                <img v-img-url="scope.row.templateCover"-->
          <!--                     style="width: 100%"/>-->
          <!--              </div>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column prop="createTime" label="添加时间" width="160"></el-table-column>
          <!--          <el-table-column prop="updateTime" label="更新时间"></el-table-column>-->
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row.pageId)" type="text" size="small" v-auth="'/page/page/edit'">编辑
              </el-button>
              <el-button @click="deleteClick(scope.row.pageId)" type="text" size="small" v-auth="'/page/page/delete'">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
                       :current-page="curPage"
                       :page-size="pageSize" layout="total, prev, pager, next, jumper"
                       :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

    <el-dialog title="模版封面" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
               :close-on-press-escape="false">
      <el-form size="small" ref="templateForm" :model="templateForm">
        <el-form-item label="模版封面" prop="templateCoverId"
                      :rules="[{required: true,message: '请输入模版封面图片',type:'number'}]">
          <el-button @click="chooseImg">选择图片</el-button>
          <img class="mt10" v-img-url="templateForm.templateCover" width="200">
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
    <Upload v-if="isupload" :isupload="isupload" :config="{ total: 1 }" @returnImgs="returnImgsFunc"></Upload>
  </div>
</template>

<script>
import PageApi from '@/api/page.js'
import Upload from '@/components/file/Upload'

export default {
  components: {Upload},
  data () {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      templateForm: {
        pageId: 0,
        templateCoverId: '',
        templateCover: ''
      },
      dialogVisible: false,
      /*是否打开图片选择*/
      isupload: false
    }
  },
  created () {
    /*获取列表*/
    this.getTableList()

  },
  methods: {
    /*选择第几页*/
    handleCurrentChange (val) {
      let self = this
      self.curPage = val
      self.loading = true
      self.getTableList()
    },

    /*每页多少条*/
    handleSizeChange (val) {
      this.curPage = 1
      this.pageSize = val
      this.getTableList()
    },

    /*获取列表*/
    getTableList () {
      let self = this
      let Params = {}
      Params.pageIndex = self.curPage
      Params.pageSize = self.pageSize
      PageApi.PageSolutionList(Params, true).then(res => {
        self.loading = false
        self.tableData = res.data.list.records
        self.totalDataNumber = res.data.list.total
      }).catch(error => {

      })
    },

    /*删除数据*/
    deleteClick (row) {
      let self = this
      self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.loading = true
        PageApi.deletePage({
          pageId: row
        }, true).then(data => {
          if (data.code == 1) {
            self.loading = false
            self.$message({
              message: '恭喜你，删除成功',
              type: 'success'
            })
            self.getTableList()
          } else {
            self.loading = false
          }
        })
          .catch(error => {
            self.loading = false
          })

      }).catch(() => {
      })
    },

    /*添加页面*/
    addClick () {
      this.$router.push('/page/page/addsolution')
    },

    templateCoverClick (row) {
      this.templateForm = {
        pageId: row.pageId || 0,
        templateCoverId: row.templateCoverId || '',
        templateCover: row.templateCover || ''
      }
      this.dialogVisible = true
    },
    dialogFormVisible () {

    },
    submit () {
      let self = this
      let form = self.templateForm
      self.$refs.templateForm.validate(valid => {
        if (valid) {
          PageApi.uploadTemplateCover(form, true).then(res => {
            self.$message({
              message: '恭喜你，设置成功',
              type: 'success'
            })
            self.getTableList()
            this.dialogVisible = false
          })
        }
      })
    },
    /*设为首页*/
    setHomeClick (page_id) {
      let self = this
      self.$confirm('确定要将此页面设置为默认首页吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.loading = true
        PageApi.setHome({
          page_id: page_id
        }, true).then(data => {
          self.loading = false
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，设置成功',
              type: 'success'
            })
            self.getTableList()
          } else {
            self.$message.error('错了哦，这是一条错误消息')
          }
        })
          .catch(error => {
            self.loading = false
          })

      }).catch(() => {

      })
    },

    /*编辑*/
    editClick (pageId) {
      let self = this
      self.$router.push({
        path: '/page/page/editsolution',
        query: {
          pageId: pageId
        }
      })

    },
    /*选择图片*/
    chooseImg () {
      this.isupload = true
    },

    /*关闭选择图片*/
    returnImgsFunc (e) {
      this.isupload = false
      if (e != null && e.length > 0) {
        this.templateForm.templateCoverId = e[0].fileId
        this.templateForm.templateCover = e[0].filePath
      }
    },
  }
}
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/crop/solution/index.vue